import { createAction, props } from '@ngrx/store';

export const setFlag = createAction(
  '[Feature Flags] Set flag',
  props<{ name: string, value: boolean, defaultValue: boolean }>()
)
